import { FormConfig } from '../../models/dynamic.model';
import { TableColumnsProp } from '../../models/tables.model';

const isSelectedAndDefaultView = {
  isSelected: true,
  defaultView: true,
};

const LABELS = {
  INVOICE_NUMBER: 'Invoice Number',
  INVOICE_DATE: 'Invoice Date',
  PUBLISHED: 'Published to GP',
  CHARGE_CODE: 'IBC Charge Code',
  CHARGE_AMOUNT_DOLLAR: 'Charge Amount ($)',
  CHARGE_DESCRIPTION: 'IBC Charge Description',
};

export const arChargesTableConfig: TableColumnsProp[] = [
  {
    key: 'invoiceNumber',
    label: LABELS.INVOICE_NUMBER,
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 150,
  },
  {
    key: 'invoiceDate',
    label: LABELS.INVOICE_DATE,
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 120,
  },
  {
    key: 'published',
    label: LABELS.PUBLISHED,
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 100,
  },
  {
    key: 'chargeCode',
    label: LABELS.CHARGE_CODE,
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 130,
  },
  {
    key: 'chargeAmount',
    label: LABELS.CHARGE_AMOUNT_DOLLAR,
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 150,
  },
  {
    key: 'chargeDescription',
    label: LABELS.CHARGE_DESCRIPTION,
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 200,
  },
];

export const numericFields = ['chargeAmount'];

export const arChargeCodeFormConfig: FormConfig = {
  fields: [
    {
      id: 'arInvoiceId',
      type: 'hidden',
      label: 'AR Invoice ID',
    },
    {
      id: 'shipmentIdentifierId',
      type: 'hidden',
      label: 'Shipment Identifier ID',
    },
    {
      id: 'chargeCodeId',
      type: 'hidden',
      label: 'Charge Code ID',
    },
    {
      id: 'invoiceNumber',
      type: 'input',
      label: LABELS.INVOICE_NUMBER,
      maxValue: 126,
      allowAlphaNumeric: true,
    },
    {
      id: 'invoiceDate',
      type: 'input',
      label: LABELS.INVOICE_DATE,
      isDisableField: true,
    },
    {
      id: 'published',
      type: 'input',
      label: LABELS.PUBLISHED,
      isDisableField: true,
    },
    {
      id: 'chargeCode',
      type: 'input',
      label: LABELS.CHARGE_CODE,
    },
    {
      id: 'chargeAmount',
      type: 'input',
      label: LABELS.CHARGE_AMOUNT_DOLLAR,
      allowNumericWithDecimal: true,
      maxValue: 10,
    },
    {
      id: 'chargeDescription',
      type: 'input',
      label: LABELS.CHARGE_DESCRIPTION,
      isDisableField: true,
    },
    {
      id: 'tempId',
      type: 'extra',
    },
    {
      id: 'isRowDisable',
      type: 'extra',
    },
    {
      id: 'id',
      type: 'extra',
    },
    {
      id: 'action',
      type: 'extra',
    },
  ],
};

export const arChargesFieldNames = {
  arInvoiceId: 'arInvoiceId',
  invoiceChargesId: 'invoiceChargesId',
  shipmentIdentifierId: 'shipmentIdentifierId',
  chargeCodeId: 'chargeCodeId',
  shipmentIdentifier: 'shipmentIdentifier',
};
